export enum PaymentStatus {
    Paid = 'Paid',
    Overdue = 'Overdue',
    Unpaid = 'Unpaid'
}
